import React, { Component } from 'react';
import Card from '@material-ui/core/Card';
import { CardText } from 'material-ui/Card';
import { MdKeyboardArrowDown as DownArrow } from 'react-icons/md';
import { MdKeyboardArrowUp as UpArrow } from 'react-icons/md';
import { AreaChart, Area, XAxis, Tooltip, ResponsiveContainer, YAxis, Legend } from 'recharts';
import { formatHoursDays, titleize } from 'helpers/Formatter';
import { colors, shadeColor } from 'helpers/ColorHelper';
import { getTimeRange } from 'helpers/DateHelper';

const style = {
  transactionCard: {
    color: '#424242 !important',
    fontFamily: '"Circular", sans-serif !important',
    height: '100%',
    overflow: 'hidden',
    borderRadius: '8px',
    boxShadow: '1px 4px 15px rgba(0, 0, 0, 0.15)',
    padding: '15px',
  },
};

class RespondFixCloseChart extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hidden: false,
    };
  }

  getData = () => {
    const { graphData, level, timePeriod } = this.props;
    return graphData[level].time_series.map((time, index) => {
      const timeRange = graphData[level].time_range;
      return {
        time: getTimeRange(time, timeRange),
        Respond: formatHoursDays(graphData[level].series_time_respond_minutes[index], timePeriod),
        Fix: formatHoursDays(graphData[level].series_time_fix_minutes[index], timePeriod),
        Close: formatHoursDays(graphData[level].series_time_close_minutes[index], timePeriod),
      };
    });
  };

  showHide = () => {
    this.setState((prevState) => ({ hidden: !prevState.hidden }));
  };

  render() {
    const { graphData, level } = this.props;
    const { hidden } = this.state;
    if (!graphData[level].children) return null;
    if (graphData[level].childen && graphData[level].childen.length === 0) return null;

    return (
      <div className="col-sm-6">
        <div className="row">
          <h3 style={{ padding: '0 15px', marginBottom: '20px' }}>
            <button
              type="button"
              className="link-button"
              onClick={this.showHide}
              style={{ color: 'inherit' }}
            >
              Time to Respond / Fix / Close
              <span>
                {hidden && <UpArrow size={24} />}
                {!hidden && <DownArrow size={24} />}
              </span>
            </button>
          </h3>
        </div>
        {this._renderGraph()}
      </div>
    );
  }

  _renderGraph = () => {
    if (this.state.hidden) return null;
    const { onClick, timePeriod } = this.props;
    return (
      <div className="row" style={{ padding: '0', height: '100%' }}>
        <Card style={style.transactionCard}>
          <CardText expandable={true} style={{ padding: '0' }}>
            <ResponsiveContainer height={300}>
              <AreaChart
                width={600}
                height={400}
                data={this.getData()}
                margin={{ top: 5, right: 30, left: 20, bottom: 5 }}
                onClick={(params) => onClick(params, 'time')}
              >
                <XAxis type="category" dataKey="time" />
                <YAxis
                  label={{ value: titleize(timePeriod), angle: -90, position: 'insideLeft' }}
                />
                <Legend verticalAlign="top" height={36} />
                <Tooltip />
                <Area
                  dataKey="Respond"
                  stackId="1"
                  fill={colors.BLUE}
                  stroke={shadeColor(colors.BLUE, -0.2)}
                />
                <Area
                  dataKey="Fix"
                  stackId="1"
                  fill={colors.YELLOW}
                  stroke={shadeColor(colors.YELLOW, -0.2)}
                />
                <Area
                  dataKey="Close"
                  stackId="1"
                  fill={colors.RED}
                  stroke={shadeColor(colors.RED, -0.2)}
                />
              </AreaChart>
            </ResponsiveContainer>
          </CardText>
        </Card>
      </div>
    );
  };
}

export default RespondFixCloseChart;
